import type { IChosenItem } from "../../../../app/@types/chosenItems";
import { KeywordAdvancedFilterService } from "../../../../app/services/AdvancedFilterService/KeywordsAdvancedFilters";
import type { IGroup } from "../../GapAnalysis/src/GapAnalysis";

interface IKeywordsAdvancedFilterGroup extends IChosenItem, IGroup {}

export const KeywordsAdvancedFilterUtils = {
    getAdvancedFilterGroups: (domains, advancedFilter): IKeywordsAdvancedFilterGroup[] => {
        const [mainDomain, ...competitors] = domains;
        // if there is no selected advanced filter, the main site gets 0% - 100%
        if (!advancedFilter) {
            return [
                KeywordsAdvancedFilterUtils.addRange(mainDomain),
                ...competitors.map((c) => KeywordsAdvancedFilterUtils.addRange(c, null)),
            ];
        }
        return KeywordAdvancedFilterService.parseApi(advancedFilter, domains);
    },
    getButtonText: (selectedFilter, i18n) =>
        selectedFilter ? null : i18n("analysis.source.search.keywords.filters.advanced.addcompetitor"),
    addRange: (domain, value = [0, 100]) => {
        return {
            ...domain,
            range: value && { value },
        };
    },
};
